import { get, set } from 'lodash'
import type { Entries } from 'type-fest'
import type { Arrayable } from './types'

export const keysOf = <T extends Object>(arr: T) => Object.keys(arr) as Array<keyof T>
export const entriesOf = <T extends Object>(arr: T) => Object.entries(arr) as Entries<T>
export { hasOwn } from '@vue/shared'

export const getProp = <T = any>(
  obj: Record<string, any>,
  path: Arrayable<string>,
  defaultValue?: any
): { value: T } => {
  return {
    get value() {
      return get(obj, path, defaultValue)
    },
    set value(val: any) {
      set(obj, path, val)
    },
  }
}
